module.exports = __webpack_public_path__ + "img/ic_burger_home-active.ce976dfd.svg";